/** CoStar.Api.Brokers.ViewModels.PropertyContactRoles.LocationLevels */
export var LocationLevels;
(function (LocationLevels) {
    LocationLevels[LocationLevels["None"] = 0] = "None";
    LocationLevels[LocationLevels["Location"] = 1] = "Location";
    LocationLevels[LocationLevels["HqLocation"] = 2] = "HqLocation";
    LocationLevels[LocationLevels["ParentLocation"] = 4] = "ParentLocation";
    LocationLevels[LocationLevels["UltimateLocation"] = 8] = "UltimateLocation";
    LocationLevels[LocationLevels["NameMatchedUltimateLocation"] = 16] = "NameMatchedUltimateLocation";
})(LocationLevels || (LocationLevels = {}));
